
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { TestPrice } from '../aitest/TestPrice'
import { Description } from '../aitest/Description'
import { Context } from '../aitest/Context'
import { Subtopics } from '../aitest/Subtopics'
import { ConnectedAccountDialog } from '../purchasetest/ConnectedAccountDialog'
//import { ExpandLess, ExpandMore } from "@mui/icons-material"
//import { Account } from '../aitest/Account'
import { DialogTestLanguage } from './DialogTestLanguage';
import { PushButton } from '../pushbutton/PushButton'
import { useState, useEffect } from "react";
import { ConfirmDialog } from '../alertdialog/ConfirmDialog';
import { DialogTestSchool } from './DialogTestSchool'
import { DialogTestSchoolYear } from './DialogTestSchoolYear'
import { TestLanguage } from './TestLanguage'
import { PageTitle } from './PageTitle'
import { TestCollege } from './TestCollege'
import { TestSchoolYear } from './TestSchoolYear'

import "./aitest.css"

export const CreateCollegeTest = () => {
  const [openConfirmDialog, handleConfirmDisplay] = useState(false);
  const [dialogtext, setDialogText] = useState('');

  const {
    changeLanguage,
    isMe,
    setTestLanguage,
    testlanguage
  } = React.useContext(StatusContext);

  const {
    onChangeContext,
    topic,
    setCreatorName,
    creatorname,
    isLoading,
    testprice,
    description,
    onChangeDescription,
   
    onNewQuestions,
    promptsandresponses,
    createcollegetestmode,

    getTestLanguage, 
   
    setSchoolYear, 
    getSchoolYear,

    setCollegeIndex,
    getCollegeIndex,

    onAutogenerateQuestions,
 
  } = React.useContext(AITestContext);

   useEffect(() => {
      console.log("useEffect:CreateCollegeTest")
      setTestLanguage(getTestLanguage())
      setCollegeIndex(getCollegeIndex())
      setSchoolYear(getSchoolYear())
    }, [setTestLanguage, getTestLanguage, setCollegeIndex, getCollegeIndex, setSchoolYear, getSchoolYear])   


const openConfirmDialogBox = () => {
    handleConfirmDisplay(true);
}

const closeConfirmDialogBox = () => {
    handleConfirmDisplay(false);
};

const confirmYes = () => {
    closeConfirmDialogBox()
}

const handleonAutogenerateQuestions = () => {

  if (createcollegetestmode)
  {
    if (promptsandresponses.length > 200)
    {
      setDialogText(changeLanguage('aitest', 'questionslimit'))
      openConfirmDialogBox()
    }
    else
      onAutogenerateQuestions()
  }
  else if (promptsandresponses.length > 60)
    {
      setDialogText(changeLanguage('aitest', 'questionslimit'))
      openConfirmDialogBox()
    }
    else 
      onNewQuestions(-1)
}

  return (
    <div>
       <div className='moveRight' >
        <PageTitle title={changeLanguage('aitest', 'createcollegeteststitle')}/>
     
        <TestLanguage language={testlanguage}/>
      
        <TestCollege />

        <TestSchoolYear />

        <br/>

        <div className="aitestAuthorSpace">
        <label className='aitestAuthorLabel'>{changeLanguage('aitest', 'creatorname')}: </label>
        <input type="text" maxLength="40" className="aitestAuthor"
          value={creatorname} onChange={(e) => setCreatorName(e.target.value)} />
      </div>
   
      {
        isMe() &&
        <>
        {/*
          <div style = {{marginTop:'20px', marginBottom:'10px'}}> 
        
            {changeLanguage('aitest', 'createaccounttext')}
          </div>
   
          <div className="accountButton" onClick={() => { onMyAccount() }}>
            {
              (showaccount) ?
                <ExpandLess className="aitestIcon" />
                :
                <ExpandMore className="aitestIcon" />
            }
            {changeLanguage('aitest', 'activity')}
          </div>
          <br></br>

        <div style={{marginTop:'20px'}}>
          {
            (showaccount) &&
            <Account balance={accountbalance} />
          }
          </div>
        */}
          <br/>
          <TestPrice price={testprice} />
          <br/>
        
      </>
      }
  
      <div className = 'descriptionStyle'>
        <Description title={changeLanguage('aitest', 'description')} description={description} placeholder={changeLanguage('aitest', 'descriptionprompt')} onChange={onChangeDescription} />
      </div>
      <br></br>

        <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', alignItems: 'flex-start' }}>
          {
            <div className = 'descriptionStyle' >
              <Context
                topic={topic}
                disabled={isLoading}
                onChange={event => onChangeContext(event)}
               
                />
              <br/>
              <Subtopics />
               <PushButton onClick={handleonAutogenerateQuestions} label="Autogenerate" disablebutton={topic.length > 0 ? false : true} />
            </div>
          }

              
        </div>
       </div>

{/*
        <div ref={descriptionRef} >
          <Questions />
        </div>
*/}        
      <ConnectedAccountDialog />
       <DialogTestLanguage requesttests={true}/>
       <DialogTestSchool />
       <DialogTestSchoolYear />
       <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogtext}/>
    </div>

  )
}

